package fr.frux.feature.blockedusers

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [BlockedUsersViewModel], honoré par le composition root (#43). */
fun interface BlockedUsersViewModelFactory {
    fun create(): BlockedUsersViewModel
}

/** Fabrique installée par le composition root, sans défaut : l'oubli de câblage doit crier. */
val LocalBlockedUsersViewModelFactory =
    staticCompositionLocalOf<BlockedUsersViewModelFactory> {
        error(
            "BlockedUsersViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

@Composable
fun rememberBlockedUsersViewModel(): BlockedUsersViewModel {
    val factory = LocalBlockedUsersViewModelFactory.current
    return viewModel { factory.create() }
}
